export default "__VITE_ASSET__DVtGSAfn__"